import { render } from "./IndexTemplate.vue?vue&type=template&id=69762a68"
import script from "./IndexTemplate.vue?vue&type=script&lang=js"
export * from "./IndexTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__